

exports.__esModule = true;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Route.extend('$xoUpdatePinRoute', {
    path: 'updatePin',
    directive: _directive2['default'],
    children: []
});


_index.$Route;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/topup/update-pin/route.js
// module id = ./components/xo-wallet-components/src/topup/update-pin/route.js
// module chunks = 1